module.exports = __webpack_public_path__ + "static/b-srevice-6de8e9a69476cd3029d8c7ec5bc25308.png";